<button
  mat-icon-button
  [ngStyle]="{ left: isExpanded ? '225px' : '130px' }"
  id="toggle"
  (click)="toggleDrawer()"
  class="drawer-toggle-button no-print">
  <span class="material-symbols-rounded">
    {{ isExpanded ? 'chevron_left' : 'chevron_right' }}</span
  >
</button>
<mat-drawer-container class="main-drawer-container" autosize>
  <!-- Botón de expansión reposicionado fuera del drawer -->

  <mat-drawer
    #drawer
    [mode]="drawerMode"
    class="no-print"
    opened
    appResizableDrawer>
    <div class="drawer-header">
      <!-- Se eliminó el botón de expandir de aquí -->
      <button
        id="close-button"
        mat-icon-button
        (click)="closeMenu()"
        class="close-menu-button">
        <span class="material-symbols-rounded">close</span>
      </button>
    </div>
    @if (isExpanded) {
      <div class="piot-image">
        <img alt="4Piot" src="assets/slide-login/4piot-logotipo.webp" />
      </div>
    } @else {
      <div class="piot-image-short">
        <img alt="4Piot" src="assets/slide-login/logo_reducido.png" />
      </div>
    }
    <div class="menu-divider"></div>
    <div class="main-menu" [class.firefox]="firefox">
      <app-menu-items
        (clickedLeaf)="closeMenu()"
        [filteredItems]="filteredItems"
        [menuSize]="menuSize"
        [searchedItem]="searchedItem">
      </app-menu-items>
    </div>

    <div class="footer">
      <app-footer-menu (clickedLeaf)="closeMenu()"></app-footer-menu>
    </div>
  </mat-drawer>
  <div class="example-sidenav-content">
    <div class="toolbar" #toolbar>
      <app-mobile-toolbar [drawer]="drawer"></app-mobile-toolbar>
    </div>
    <app-modal-form-home>
      @if (component === 'notifications') {
        <app-notifications-panel form></app-notifications-panel>
      } @else {
        <app-modal-home form (closeModal)="drawer.close()"></app-modal-home>
      }
      <div
        router
        class="route-host"
        [class.route-host--loading]="routeLoading()">
        <router-outlet></router-outlet>
        @if (routeLoading()) {
          @if (routeSkeleton() === 'map') {
            <div
              class="route-skeleton route-skeleton--map"
              aria-busy="true"
              role="status"
              aria-live="polite"
              aria-label="Cargando mapa">
              <div class="route-skeleton__map">
                <ngx-skeleton-loader
                  class="route-skeleton__map-canvas"
                  appearance="line"
                  aria-hidden="true"
                  [theme]="{
                    height: '100%',
                    width: '100%',
                    'border-radius': '16px',
                    margin: '0',
                  }" />
                <div class="route-skeleton__map-controls">
                  <ngx-skeleton-loader
                    appearance="line"
                    aria-hidden="true"
                    [theme]="{
                      height: '40px',
                      width: '260px',
                      'border-radius': '20px',
                      margin: '0',
                    }" />
                  <ngx-skeleton-loader
                    appearance="line"
                    aria-hidden="true"
                    [theme]="{
                      height: '32px',
                      width: '128px',
                      'border-radius': '16px',
                      margin: '0',
                    }" />
                  <ngx-skeleton-loader
                    appearance="line"
                    aria-hidden="true"
                    [theme]="{
                      height: '32px',
                      width: '112px',
                      'border-radius': '16px',
                      margin: '0',
                    }" />
                  <ngx-skeleton-loader
                    appearance="line"
                    aria-hidden="true"
                    [theme]="{
                      height: '32px',
                      width: '140px',
                      'border-radius': '16px',
                      margin: '0',
                    }" />
                </div>
              </div>
            </div>
          } @else {
            <div class="route-skeleton" aria-busy="true">
              <ngx-skeleton-loader
                class="route-skeleton__title"
                appearance="line"
                aria-hidden="true"
                [theme]="{
                  height: '28px',
                  width: '320px',
                  'border-radius': '8px',
                  margin: '0',
                }" />
              <ngx-skeleton-loader
                class="route-skeleton__card"
                appearance="line"
                aria-hidden="true"
                [theme]="{
                  height: '96px',
                  width: '100%',
                  'border-radius': '20px',
                  margin: '0',
                }" />
              <app-content-skeleton
                appearance="table"
                ariaLabel="Cargando sección" />
            </div>
          }
        }
      </div>
    </app-modal-form-home>
  </div>

  <!-- Contenido principal fuera de los modales -->
  <!-- @if (component === 'home') {
  <app-modal-form *ngIf="component === 'home'">
    <app-modal-home
      form
      *ngIf="component === 'home'"
      (closeModal)="drawer.close()">
    </app-modal-home>
  </app-modal-form>
  } @else {
  <div class="example-sidenav-content">
    <router-outlet router></router-outlet>
  </div>
  } -->
  <!-- <div class="example-sidenav-content">
    <router-outlet router></router-outlet>
  </div>
  <app-modal-form *ngIf="component === 'home'">
    <app-modal-home
      form
      *ngIf="component === 'home'"
      (closeModal)="drawer.close()">
    </app-modal-home>
  </app-modal-form> -->
</mat-drawer-container>
